import React from "react";
import { Button, Modal } from "antd";
import { CloseOutlined, LockOutlined } from "@ant-design/icons";

export type PasswordChangedModalProps = {
  open: boolean;
  onClose: () => void;
  onBackToLogin: () => void;
};

export const PasswordChangedModal: React.FC<PasswordChangedModalProps> = ({
  open,
  onClose,
  onBackToLogin,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      destroyOnClose
      className="password-changed-modal modal-round"
      closeIcon={<CloseOutlined className="password-changed-close-icon" />}
    >
      <div className="password-changed-hero">
        <div className="password-changed-hero-wave" />
        <div className="password-changed-hero-icon" aria-hidden>
          <LockOutlined />
        </div>
      </div>

      <div className="password-changed-content">
        <div className="password-changed-title">Password Changed Successfully</div>
        <div className="password-changed-subtitle">
          Your password has been updated successfully
        </div>

        <Button
          type="primary"
          size="large"
          className="password-changed-btn"
          onClick={onBackToLogin}
        >
          Back to Log In
        </Button>
      </div>
    </Modal>
  );
};

export default PasswordChangedModal;

